module["exports"] = [
  "#{street_name}#{building_number}",
  "#{street_name}#{building_number} #{secondary_address}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/street_address.js
// module id = 755
// module chunks = 0